import { COLOR_MAP } from 'src/utils/constants/scss-variables.constants';

const chartColorScale = [
  COLOR_MAP['light-blue'],
  COLOR_MAP.blue,
  COLOR_MAP.turquoise,
  COLOR_MAP.purple,
  COLOR_MAP.orange,
  COLOR_MAP.yellow,
  COLOR_MAP['gray-light'],
  COLOR_MAP.red,
  COLOR_MAP['gray-dark'],
  COLOR_MAP.pink,
];

export default chartColorScale;
